'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-start;\n  transition: background-color 1s;\n  aside {\n    transform: translateX(64vh) translateX(-2rem);\n    transition: transform 1s;\n    @media (max-width: 500px) {\n      transform: translateX(100vw);\n    }\n  }\n  &.active {\n    pointer-events: auto;\n    background-color: rgba(0,0,0,0.5);\n    aside {\n      transform: translateX(0vw);\n    }\n  }\n'], ['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 30;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-start;\n  transition: background-color 1s;\n  aside {\n    transform: translateX(64vh) translateX(-2rem);\n    transition: transform 1s;\n    @media (max-width: 500px) {\n      transform: translateX(100vw);\n    }\n  }\n  &.active {\n    pointer-events: auto;\n    background-color: rgba(0,0,0,0.5);\n    aside {\n      transform: translateX(0vw);\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: calc(64vh - 2rem);\n  height: calc(100vh - 2rem);\n  background-color: rgba(0,0,0,0.5);\n  @media (max-width: 500px) {\n    width: 100vw;\n    height: 156vw;\n  }\n'], ['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: calc(64vh - 2rem);\n  height: calc(100vh - 2rem);\n  background-color: rgba(0,0,0,0.5);\n  @media (max-width: 500px) {\n    width: 100vw;\n    height: 156vw;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  top: 3rem;\n  margin-left: -2rem;\n  div {\n    line-height: 2rem;\n  }\n  .fa {\n    margin-bottom: 1rem;\n  }\n  :hover {\n    color: gold;\n  }\n'], ['\n  width: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  top: 3rem;\n  margin-left: -2rem;\n  div {\n    line-height: 2rem;\n  }\n  .fa {\n    margin-bottom: 1rem;\n  }\n  :hover {\n    color: gold;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  background: linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0.5));\n  width: 4rem;\n  height: calc(100vh - 2rem);\n  position: absolute;\n  top: 2rem;\n  left: 0;\n  margin-left: -4rem;\n'], ['\n  pointer-events: none;\n  background: linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,0.5));\n  width: 4rem;\n  height: calc(100vh - 2rem);\n  position: absolute;\n  top: 2rem;\n  left: 0;\n  margin-left: -4rem;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: cover;\n  background-image: url(', ');\n'], ['\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: cover;\n  background-image: url(', ');\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  .fa {\n    margin: 0 0.5rem;\n  }\n  &:hover {\n    color: gold;\n  }\n'], ['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  .fa {\n    margin: 0 0.5rem;\n  }\n  &:hover {\n    color: gold;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-size: 1.5rem;\n  text-align: center;\n  margin-top: 2rem;\n  .fa {\n    margin-right: 0.5rem;\n  }\n'], ['\n  width: 100%;\n  font-size: 1.5rem;\n  text-align: center;\n  margin-top: 2rem;\n  .fa {\n    margin-right: 0.5rem;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 2.5rem;\n  overflow: auto;\n  a, button {\n    cursor: pointer;\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    margin: 0;\n    margin-bottom: 0.1rem;\n    padding: 0.5rem 0.5rem;\n    font-size: 1.2rem;\n    text-align: left;\n    text-decoration: none;\n    border-radius: 0.5rem;\n    border: 2px solid #333;\n    color: #333;\n    background-color: orange;\n    &:hover {\n      background-color: #777;\n      color: #fff;\n    }\n    .fa {\n      margin: 0 0.5rem;\n    }\n  }\n'], ['\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 2.5rem;\n  overflow: auto;\n  a, button {\n    cursor: pointer;\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    margin: 0;\n    margin-bottom: 0.1rem;\n    padding: 0.5rem 0.5rem;\n    font-size: 1.2rem;\n    text-align: left;\n    text-decoration: none;\n    border-radius: 0.5rem;\n    border: 2px solid #333;\n    color: #333;\n    background-color: orange;\n    &:hover {\n      background-color: #777;\n      color: #fff;\n    }\n    .fa {\n      margin: 0 0.5rem;\n    }\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  @media (max-width: 500px) {\n    height: 6rem;\n  }\n'], ['\n  @media (max-width: 500px) {\n    height: 6rem;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _locationItem = require('./location-item');

var _locationItem2 = _interopRequireDefault(_locationItem);

var _featureItem = require('./feature-item');

var _featureItem2 = _interopRequireDefault(_featureItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // TODO: Custom button colors
// TODO: Link to showcase
// TODO: Link to gift registry

var Wrapper = _styledComponents2.default.div(_templateObject);

var Sidebar = _styledComponents2.default.aside(_templateObject2);

var ShowLocationsButton = _styledComponents2.default.div(_templateObject3);

var Shade = _styledComponents2.default.div(_templateObject4);

var Background = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.image;
});

var CloseButton = _styledComponents2.default.div(_templateObject6);

var Title = _styledComponents2.default.div(_templateObject7);

var Menu = _styledComponents2.default.nav(_templateObject8);

// Padding for mobile devices
var Pad = _styledComponents2.default.div(_templateObject9);

/** @class ShowLocations
  * A component to display show locations and enabled show features
  * in a slide-out side menu.
  * @param {string} name - the name of the show.
  * @param {Object} halls - the halls in the show.
  * @param {URLString} background (optional) - the background image ot display
  */

var ShowLocations = function (_Component) {
  _inherits(ShowLocations, _Component);

  /** @constructor
    * Creates a new instance of ShowLocations
    */
  function ShowLocations(props) {
    _classCallCheck(this, ShowLocations);

    var _this = _possibleConstructorReturn(this, (ShowLocations.__proto__ || Object.getPrototypeOf(ShowLocations)).call(this, props));

    var locations = [{
      id: 'lobby',
      icon: 'home',
      text: 'Lobby',
      path: '/lobby',
      onClick: function onClick() {
        _this.setState({ visible: false });
      }
    }];
    Object.keys(props.halls).sort(function (keyA, keyB) {
      return props.halls[keyA].order - props.halls[keyB].order;
    }).forEach(function (key) {
      locations.push({
        id: key,
        icon: 'flag',
        text: props.halls[key].name,
        path: '/hall/' + key,
        onClick: function onClick() {
          window.location.hash = '/hall/' + key;
          _this.setState({ visible: false });
        }
      });
    });
    var features = [{
      id: 'booth-list',
      icon: 'map',
      text: 'Exhibitor Listing',
      onClick: function onClick() {
        window.vexpo.showBoothListing();
        _this.setState({ visible: false });
      }
    }, {
      id: 'purchase-gift-cards',
      icon: 'money',
      text: 'Discount Coupons',
      path: '/fundraising',
      onClick: function onClick() {
        if (window.vexpo.giftCards && window.vexpo.giftCards.purchased) {
          window.vexpo.giftCards.show();
        } else {
          window.location.hash = 'fundraising';
        }
        _this.setState({ visible: false });
      }
    }];
    // Only offer showbag if functionality is enabled
    if (window.vexpo && window.vexpo.showbag) {
      features.push({
        id: 'showbag',
        icon: 'star',
        text: 'My Favorites',
        onClick: function onClick() {
          window.vexpo.showbag.show();
          _this.setState({ visible: false });
        }
      });
    }
    // Only offer sign-in and sign-out option if auth is required
    if (!_this.props.isSample) {
      if (window.vexpo && window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) {
        // Only offer sign-out if the user is signed in
        features.push({
          id: 'sign-out',
          icon: 'sign-out',
          text: 'Sign Out',
          onClick: function onClick() {
            if (window.vexpo && window.vexpo.firebase) {
              window.vexpo.firebase.auth().signOut();
            }
          }
        });
      } else {
        // Only offer sign-in if the user is not signed in
        features.push({
          id: 'sign-in',
          icon: 'sign-in',
          text: 'Sign In',
          onClick: function onClick() {
            if (window.vexpo && window.vexpo.requestLoginLink) {
              window.vexpo.requestLoginLink();
            }
          }
        });
      }
    }
    // Always add contact us
    features.push({
      id: 'contact-us',
      icon: 'paper-plane',
      text: 'Contact Us',
      onClick: function onClick() {
        if (vexpo.overlay) {
          vexpo.overlay({
            type: 'article',
            html: '<div>\n                <h1>Contact Us</h1>\n                <p>\n                  If you have any questions or concerns\n                  about the ' + _this.props.name + ', please\n                  contact us at <a href="mailto:' + _this.props.supportEmail + '">\n                  ' + _this.props.supportEmail + '</a>.\n                </p>\n              </div>'
          });
        } else {
          window.location = 'mailto:info@vexposhows.com';
          _this.setState({ visible: false });
        }
      }
    });
    _this.state = {
      visible: false,
      locations: locations,
      features: features
    };
    return _this;
  }
  /** @method componentDidMount
    * Adds the showLocations() function to the global vexpo object.
    */


  _createClass(ShowLocations, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      window.vexpo.showLocations = function () {
        _this2.setState({ visible: true });
      };
    }
    /** @method render
      * Renders the component.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var locations = this.state.locations.map(function (loc) {
        return _react2.default.createElement(_locationItem2.default, { key: loc.id, text: loc.text, icon: loc.icon, to: loc.path, onClick: loc.onClick });
      });
      var features = this.state.features.map(function (feat) {
        return _react2.default.createElement(_featureItem2.default, _extends({ key: feat.id }, feat, { icon: feat.icon, onClick: feat.onClick }));
      });
      var label = [_react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' }), 'L', 'O', 'C', 'A', 'T', 'I', 'O', 'N', 'S'].map(function (c, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          c
        );
      });
      return _react2.default.createElement(
        Wrapper,
        { className: this.state.visible ? "active" : "" },
        _react2.default.createElement(
          Sidebar,
          null,
          _react2.default.createElement(Shade, null),
          _react2.default.createElement(
            ShowLocationsButton,
            { onClick: function onClick() {
                _this3.setState({ visible: true });
              } },
            label
          ),
          _react2.default.createElement(
            CloseButton,
            { onClick: function onClick() {
                _this3.setState({ visible: false });
              } },
            'CLOSE',
            _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
          ),
          _react2.default.createElement(
            Background,
            { className: 'bg', image: this.props.background },
            _react2.default.createElement(
              Menu,
              null,
              _react2.default.createElement(
                Title,
                null,
                _react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' }),
                'Locations'
              ),
              locations,
              _react2.default.createElement(
                Title,
                null,
                _react2.default.createElement(_reactFontawesome2.default, { name: 'cogs' }),
                'Features'
              ),
              features,
              _react2.default.createElement(Pad, null)
            )
          )
        )
      );
    }
  }]);

  return ShowLocations;
}(_react.Component);

exports.default = ShowLocations;


ShowLocations.propTypes = {
  name: _propTypes2.default.string.isRequired,
  halls: _propTypes2.default.object.isRequired,
  background: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/show-locations.js
// module id = 692
// module chunks = 0